import React from 'react';
import { Icon, Button } from '@abb/abb-common-ux-react';
import * as CONSTANTS from "../../utilities/Constants";
import { Translation, useTranslation } from 'react-i18next';
import { FileUploader } from "react-drag-drop-files";
import History from "../../utilities/History";
import renderBreadcrumb from '../../utilities/Breadcrumb';

interface ILandingProps {
  file: any;
  licenseFileData: any;
  licenseDetails: any;
  expirationDate: string;
  isLifeTimeValid: boolean;
  handleChange: any;
  handleFileUpload: any;
  isFileUploadFailed: boolean;
  version?: string
  onTypeError: any;
  isErrorFileType?: boolean;
}
interface IState {
}
export default class Landing extends React.Component<
  ILandingProps,
  IState
> {
  private _mount: boolean = false;
  private fileTypes = ["SLA"];

  constructor(props: ILandingProps) {
    super(props);
    this._mount = true;
    this.state = {
    };
  }


  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;
  }

  public breadcrumpClick = (link: string): void => {
    if (link) History.push(link);
  };

  public render() {
    const isSubscription = this.props.licenseDetails?.filter((x: any) => x.licenseType === "Subscription")
    const isLifeTime = this.props.licenseDetails?.filter((x: any) => x.licenseType === "Lifetime")
    return (
      <React.Fragment>
        <Translation>
          {(t) => (
            <div className="page-layout h-100">
              <div className="summary-layout mt-4">
                <div className="row" style={{flexDirection: "column"}}>
                  {renderBreadcrumb(
                    [
                      { text: t("Home"), link: "/samplenew", bolder: false },
                      { text: t(CONSTANTS.MENU_CONFIG), link: null, bolder: false },
                      { text: t(CONSTANTS.SUBMENU_LICENSE_MANAGEMENT), link: null, bolder: true }
                    ], "pl-5 pb-3")
                  }
                  <div className="name-header-font float-left license-heading">
                    {t(CONSTANTS.SUBMENU_LICENSE_MANAGEMENT)}
                  </div>
                </div>
                <div className='license-padding'>
                  <hr />
                  <div className='d-flex'>
                    <div className="col-6" style={{ borderRight: '2px solid #bababa' }}>
                      <h6 className="license-header"><b>{t(CONSTANTS.LICENSE_SUBSCRIPTION)}</b></h6>
                      <hr />
                      {isSubscription.length !== 0 ? (<div className='license-wrapper'>
                        <p><span className="license-key">{t(CONSTANTS.LICENSE_STATUS)}</span> <span className="license-colon">:</span> <span>{isSubscription[0]?.isActive ? t(CONSTANTS.LICENSE_ACTIVE) : t(CONSTANTS.LICENSE_INACTIVE)}</span></p>
                        <p><span className="license-key">{t(CONSTANTS.LICENSE_EXPIRATION_DATE)}</span> <span className="license-colon">:</span> <span>{this.props.expirationDate}</span></p>
                        <p><span className="license-key">{t(CONSTANTS.LICENSE_VERSION)}</span> <span className="license-colon">:</span> <span>{CONSTANTS.PRODUCT_NAME_WITH_VERSION}</span></p>
                      </div>) : (<div className='nolicense-wrapper'>{t(CONSTANTS.NO_SUBSCRIPTION_LICENSE_FOUND)}</div>)}
                    </div>

                    <div className="col-6">
                      <h6 className="license-header"><b>{t(CONSTANTS.LICENSE_LIFETIME)}</b></h6>
                      <hr />
                      {isLifeTime.length !== 0 ? (<div className='license-wrapper'>
                        <p><span className="license-key">{t(CONSTANTS.LICENSE_STATUS)}</span> <span className="license-colon">:</span> <span>{isLifeTime[0]?.isActive ? t(CONSTANTS.LICENSE_ACTIVE) : t(CONSTANTS.LICENSE_INACTIVE)}</span></p>
                        <p><span className="license-key">{t(CONSTANTS.LICENSE_EXPIRATION_DATE)}</span> <span className="license-colon">:</span> <span>{t(CONSTANTS.LIFETIME_LICENSE)}</span></p>
                        <p><span className="license-key">{t(CONSTANTS.LICENSE_VERSION)}</span> <span className="license-colon">:</span> <span>{`LMS_v${isLifeTime[0]?.licenseVersion}.0`}</span></p>
                      </div>) : (<div className='nolicense-wrapper'>{t(CONSTANTS.NO_LIFETIME_LICENSE_FOUND)}</div>)}
                    </div>
                  </div>

                  <hr />

                  <div className="">
                    <div className="padding-wrapper">
                      <div>
                        {!this.props.isLifeTimeValid ?
                          <>
                            {t(CONSTANTS.LICENSE_MANAGEMENT_TEXT1)} <span className='license-text-bold'>{this.props.expirationDate}</span>
                          </>
                          :
                          <>
                            {t(CONSTANTS.LICENSE_MANAGEMENT_LIFETIME)} <span className='license-text-bold'>{`LMS_v${isLifeTime[0]?.licenseVersion}.0`}</span>
                          </>
                        }
                        <br /><br />
                        {(isLifeTime.length !== 0 && !isLifeTime[0]?.isActive) && <>{t(CONSTANTS.LICENSE_MANAGEMENT_TEXT2)}
                        <br /><br /></>}
                        <div>{t(CONSTANTS.LICENCE_MANAGEMENT_SUPPORT_INFO)} <a className="mailto" href="mailto:lw.technicalsupport@se.abb.com">lw.technicalsupport@se.abb.com</a></div>
                        <br /><br />
                        <div className='license-file'>
                          <FileUploader
                            handleChange={this.props.handleChange}
                            onTypeError={this.props.onTypeError}
                            name="file"
                            types={this.fileTypes}>
                            <div className="license-text">
                              <div><Icon
                                name="abb/upload"
                                sizeClass="small"
                                style={{ cursor: "pointer" }}
                              />
                                <span className="license-upload">{this.props.file && this.props.file?.name ? this.props.file?.name : t("Select or drop a file right here")}</span></div>
                              <span className="file-types">{this.fileTypes}</span>
                            </div>
                          </FileUploader>
                          <Button type="primary-black"
                            shape="rounded"
                            text={t(CONSTANTS.SLA_UPLOAD_BUTTON)}
                            onClick={() => this.props.handleFileUpload(this.props.file)}
                            disabled={this.props.file ? this.props.isErrorFileType ? true : false : true}
                          />
                        </div>
                        {/* <p>{this.props.file ? `File name: ${this.props.file.name}` : "No files uploaded yet"}</p> */}
                        {this.props.isErrorFileType && <p className='license-upload-failed'>{t("File type is not supported")}</p>}
                        {this.props.isFileUploadFailed && <p className='license-upload-failed'>{t("File upload failed, Please try again with valid License File")}</p>}
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          )}
        </Translation>
      </React.Fragment>
    );
  }
}
